import { Injectable, NgZone } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AppRouteService {
  constructor(
    private _router: Router,
    private _ngZone: NgZone
  ) {}

  navigate(route: string, extras?: NavigationExtras): Promise<boolean> {
    return this._ngZone.run(() => this._router.navigate([route], extras));
  }

  navigateByUrl(url: string, extras?: NavigationExtras): Promise<boolean> {
    return this._ngZone.run(() => this._router.navigateByUrl(url, extras));
  }
}
